/**
 * IXD↔IXD 비교 "HTML 다운로드" 버튼.
 *
 * 라이브 결과 뷰 헤더(headerAction)로 주입된다. clone/vanilla 대신, 스토어의 tocs 를
 * 임베드해 라이브와 같은 뷰어를 CSR 하는 self-contained HTML 을 만든다.
 *
 * (이 버튼은 결과 뷰가 직접 import 하지 않는다 — 결과 뷰는 뷰어 번들에 재사용되므로,
 *  빌더 import 가 결과 뷰에 섞이면 번들 순환이 된다.)
 */

import { Download, Loader2 } from "lucide-react";

import { Button } from "@/toggle-ui-kit/button";
import { fetchAssetAsDataUri, useHtmlExport } from "@/lib/html-export";
import { logIxdPreviewCompareDownload } from "@/apis/compare/route";
import { useIxdPreviewCompareStore } from "@/stores/ixd-preview-compare";

export const IxdIxdDownloadButton = () => {
  const tocs = useIxdPreviewCompareStore((s) => s.tocs);
  const srcLabel = useIxdPreviewCompareStore((s) => s.srcLabel);
  const trgLabel = useIxdPreviewCompareStore((s) => s.trgLabel);

  const { exportNow, isExporting } = useHtmlExport({
    // 통계 집계용 — 실패해도 다운로드엔 영향 없게 fire-and-forget.
    onLogged: () => logIxdPreviewCompareDownload().catch(() => {}),
    build: async () => {
      if (!tocs.length) return null;
      const logoDataUri = await fetchAssetAsDataUri(
        "/login-assets/invector-logo.svg",
      );
      // 뷰어 번들(React + 결과 뷰 트리 IIFE 문자열)은 무겁고 다운로드 시점에만
      // 필요하므로, 정적 import 대신 동적 import 로 별도 청크로 분리한다.
      const { buildIxdIxdViewerHtml } = await import("./build-viewer-html");
      const html = buildIxdIxdViewerHtml(
        { tocs, srcLabel, trgLabel, logoDataUri: logoDataUri ?? undefined },
        "IXD Preview 비교",
      );
      return { html, filename: "ixd_preview_compare.html" };
    },
  });

  return (
    <Button
      variant="outlined"
      color="primary"
      size={32}
      leftIcon={
        isExporting ? <Loader2 className="animate-spin" /> : <Download />
      }
      disabled={tocs.length === 0 || isExporting}
      onClick={exportNow}
    >
      {isExporting ? "준비 중..." : "다운로드"}
    </Button>
  );
};
